export default __webpack_public_path__ + "static/media/2025 ORG MINUTES 04.11.25.dcf33cd8.pdf";